export const iconFontAwesomeMediaplaybackVolumeXmark = (
	<i className="fa-solid fa-volume-xmark"></i>
);
